<template>
  <div class="box-logo-l flex justify-center inline-block">
    <div class="inline-block large-logo m-auto relative">
      <div style="opacity: 0.075;">
        <img src="@/assets/images/spider-circles.png" />
      </div>
      <div class="absolute top-0 right-0 bottom-0 left-0" style="padding: 15%;">
        <img src="@/assets/logo/logo-chplus-landing.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BoxLogoL"
};
</script>

<style lang="scss" scoped>
.box-logo-l {
  height: 21.84rem;
}

.large-logo {
  width: 17rem;
  height: 17rem;
}

@media (min-width: 768px) {
  .box-logo-l {
    height: 24.704rem;
  }

  .large-logo {
    width: 19.763rem;
    height: 19.763rem;
  }
}
</style>
